// extracted by mini-css-extract-plugin
export default {"base":"Step_base__g1Epy","circle":"Step_circle__MdZhX","stepNr":"Step_stepNr__Y5Ka5","text":"Step_text__PHXuJ","active":"Step_active__NBn4t"};